import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSiteDownTimeTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FileLoading/GetSiteDownTimeHistory`
});

export const ImportSiteDownTimeFileRequest = (userId, filePath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FileLoading/DwtUpload`,
	params: { userId, filePath }
});

export const ImportTowerDBFileRequest = (userId, filePath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FileLoading/TowerDBUpload`,
	params: { userId, filePath }
});

export const ImportIncMassivaFileRequest = (userId, filePath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FileLoading/IncMassivaUpload`,
	params: { userId, filePath }
});

export const ImportIncTicketsFileRequest = (userId, filePath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FileLoading/IncTicketsUpload`,
	params: { userId, filePath }
});
